// @flow
import App from 'app/get-help/components/App';

const asyncRoute = {
  component: App,
  isAuthRequired: false,
};

export default asyncRoute;
